module.exports = __webpack_public_path__ + "static/media/HPP_Relationship_Icon.a82372ca.svg";